module.exports = __webpack_public_path__ + "../static/img/layout-4.21757e03.png";